import React, { useState } from "react";
import OrderDetailsPopup from "./OrderDetailsPopup";

const OrdersTable = ({ orders, status }) => {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isPopupOpen, setPopupOpen] = useState(false);
  // Filtrer les commandes par statut
  const filteredOrders = orders.filter((order) => order.status === status);

  const handleRowClick = (order) => {
    setSelectedOrder(order);
    setPopupOpen(true);
  };

  return (
    <div className="w-full overflow-x-auto rounded-lg">
      <table className="min-w-full bg-gray-100 border border-gray-200">
        <thead className="bg-primary text-white">
          <tr>
            <th className="px-4 py-2 font-normal text-left">Image</th>
            <th className="px-4 py-2 font-normal text-left">Titre</th>
            <th className="px-4 py-2 font-normal text-left">Date</th>
            <th className="px-4 py-2 font-normal text-left">Lieu</th>
            <th className="px-4 py-2 font-normal text-left">Prix</th>
            <th className="px-4 py-2 font-normal text-left">Quantité</th>
            <th className="px-4 py-2 font-normal text-left">Actions</th>
          </tr>
        </thead>
        <tbody className="text-onWhite">
          {filteredOrders.map((order, index) => (
            <tr key={index} className="border-t hover:bg-gray-100">
              <td className="px-4 py-2">
                <img
                  src={order.image}
                  alt={order.title}
                  className="h-16 w-24 object-cover rounded"
                  loading="lazy"
                />
              </td>
              <td className="px-4 py-2">{order.title}</td>
              <td className="px-4 py-2">{order.date}</td>
              <td className="px-4 py-2">{order.location}</td>
              <td className="px-4 py-2 font-semibold">
                ${order.price.toFixed(2)}
              </td>
              <td className="px-4 py-2">{order.quantity}</td>
              <td className="px-4 py-2">
                <button
                  onClick={(e) => {
                    e.stopPropagation(); // Empêche le clic sur la ligne de déclencher
                    handleRowClick(order);
                  }}
                  className="bg-primary text-white px-4 py-2 rounded-full hover:bg-muted"
                >
                  Consulter
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Popup */}
      <OrderDetailsPopup
        order={selectedOrder}
        isOpen={isPopupOpen}
        onClose={() => setPopupOpen(false)}
      />
    </div>
  );
};

export default OrdersTable;
